(function(window, document) {
  'use strict';

  mint.on('documentLoaded', function() {

    // -----------------------------------------------------------------------------------------------------------------
    // Desktop
    const serviceNavigation = document.querySelector('.navigation--service-desktop');
    const serviceNavigationInstance =  mint.components.navigation(serviceNavigation, {});

    const serviceNavigationSwitch = document.querySelector('.navigation--service-desktop .navigation__group-switch');
    const serviceNavigationSwitchInstance =  mint.components.switchButton(serviceNavigationSwitch, {
      durationCssVariable: '--navigation-transition-duration',
      activateCssClass: 'is--activate',
      activeCssClass: 'is--active',
      deactivateCssClass: 'is--deactivate',
      backdrop: true,
      backdropCssClassModifier: 'service-navigation'
    });

    // // Mouse-Hover
    // serviceNavigation.addEventListener('navigation.link.mousemove', function(event) {
    //   if(event.detail.groupItem.classList.contains('navigation__group-item--lv1')) {
    //     event.detail.navigation.itemActivate(event.detail.groupItem, event.detail.item);
    //   }
    // });
    //
    // serviceNavigation.addEventListener('navigation.link.mouseout', function(event) {
    //   if(event.detail.groupItem.classList.contains('navigation__group-item--lv1')) {
    //     event.detail.navigation.itemDeactivate(event.detail.groupItem, event.detail.item);
    //   }
    // });

    // Tastatur-Aktivierung
    serviceNavigationSwitch.addEventListener('switch-button.activate', function(event) {
      const targetContainer = event.detail.targetElement;
      const targetContainerHeight = targetContainer.offsetHeight;
      const parentContainer = serviceNavigationSwitch.closest('.navigation__group-item');
      const navigationWidth = serviceNavigationSwitch.closest('.navigation__group').offsetWidth;

      parentContainer.classList.add('is--activate');
      targetContainer.style.maxHeight = 0 + 'px';
      targetContainer.style.minWidth = navigationWidth + 'px';

      // Hoehe auf Zielhoehe animieren
      setTimeout(function() {
        targetContainer.style.maxHeight = targetContainerHeight + 'px';
      }, 0);
    });

    serviceNavigationSwitch.addEventListener('switch-button.activated', function(event) {
      const parentContainer = serviceNavigationSwitch.closest('.navigation__group-item');

      parentContainer.classList.add('is--active');
      parentContainer.classList.remove('is--activate');
    });

    serviceNavigationSwitch.addEventListener('switch-button.deactivate', function(event) {
      const targetContainer = event.detail.targetElement;
      const targetContainerHeight = targetContainer.offsetHeight;
      const parentContainer = serviceNavigationSwitch.closest('.navigation__group-item');

      parentContainer.classList.add('is--deactivate');
      parentContainer.classList.remove('is--active');
      targetContainer.style.maxHeight = targetContainerHeight + 'px';

      // Hoehe auf Zielhoehe animieren
      setTimeout(function() {
        targetContainer.style.maxHeight = 0 + 'px';
      }, 0);
    });

    serviceNavigationSwitch.addEventListener('switch-button.deactivated', function(event) {
      const targetContainer = event.detail.targetElement;
      const parentContainer = serviceNavigationSwitch.closest('.navigation__group-item');

      targetContainer.removeAttribute('style'); // Hoehe aus der Animation wieder entfernen
      parentContainer.classList.remove('is--deactivate');
    });

    serviceNavigation.querySelectorAll('.navigation__group-item--lv1').forEach(function(item) {
      const switchButton = item.querySelector('.navigation__group-switch');

      item.addEventListener('navigation.item.activate', function(event) {
        if(switchButton !== null) {
          serviceNavigationSwitchInstance.activate();
        }
      });

      item.addEventListener('navigation.item.deactivate', function(event) {
        if(switchButton !== null) {
          serviceNavigationSwitchInstance.deactivate();
        }
      });
    });

    // -----------------------------------------------------------------------------------------------------------------
    // Mobil
    const serviceNavigationMobile = document.querySelector('.navigation--service-mobile');
    const serviceNavigationMobileInstance =  mint.components.navigation(serviceNavigationMobile, {});

    // Einzel-Events von Items / Links verarbeiten
    serviceNavigationMobile.querySelectorAll('.navigation__group-item').forEach(function(item) {
      const link = item.querySelector('.navigation-item');
      const groupContainer = item.querySelector('.navigation__group');
      const switchButton = item.querySelector('.navigation__group-switch');

      if(switchButton !== null) {
        const switchButtonInstance = mint.components.switchButton(switchButton, {
          durationCssVariable: '--navigation-transition-duration',
          activateCssClass: 'navigation__group-switch--activate',
          activeCssClass: 'navigation__group-switch--active',
          deactivateCssClass: 'navigation__group-switch--deactivate'
        });

        switchButton.addEventListener('switch-button.activate', function(event) {
          serviceNavigationMobileInstance.itemActivate(item, link);
        });

        switchButton.addEventListener('switch-button.deactivate', function(event) {
          serviceNavigationMobileInstance.itemDeactivate(item, link);
        });
      }

      item.addEventListener('navigation.item.activate', function(event) {
        link.classList.add('navigation-item--activate');

        if(switchButton !== null) {
          switchButton.classList.add('navigation__group-switch--activate');
        }

        if(groupContainer !== null) {
          groupContainer.classList.add('navigation__group--activate');
          item.style.maxHeight = link.offsetHeight + 'px';

          setTimeout(function() {
            item.style.maxHeight = (groupContainer.offsetHeight + link.offsetHeight) + 'px';
          }, 0);
        }
      });

      item.addEventListener('navigation.item.activated', function(event) {
        link.classList.add('navigation-item--active');
        link.classList.remove('navigation-item--activate');

        if(switchButton !== null) {
          switchButton.classList.add('navigation__group-switch--active');
          switchButton.classList.remove('navigation__group-switch--activate');
        }

        if(groupContainer !== null) {
          groupContainer.classList.add('navigation__group--active');
          groupContainer.classList.remove('navigation__group--activate');
          item.removeAttribute('style'); // Hoehe aus der Animation wieder entfernen
        }
      });

      item.addEventListener('navigation.item.deactivate', function(event) {
        link.classList.add('navigation-item--deactivate');
        link.classList.remove('navigation-item--active');

        if(switchButton !== null) {
          switchButton.classList.add('navigation__group-switch--deactivate');
          switchButton.classList.remove('navigation__group-switch--active');
        }

        if(groupContainer !== null) {
          groupContainer.classList.add('navigation__group--deactivate');
          groupContainer.classList.remove('navigation__group--active');

          // Hoehenanimation -> auf die Hoehe des Links reduzieren
          item.style.maxHeight = (groupContainer.offsetHeight + link.offsetHeight) + 'px';

          setTimeout(function() {
            item.style.maxHeight = link.offsetHeight + 'px';
          }, 0);
        }
      });

      item.addEventListener('navigation.item.deactivated', function(event) {
        link.classList.remove('navigation-item--deactivate');

        if(switchButton !== null) {
          switchButton.classList.remove('switch-button--deactivate');
        }

        if(groupContainer !== null) {
          groupContainer.classList.remove('navigation__group--deactivate');
          item.removeAttribute('style'); // Hoehe aus der Animation wieder entfernen
        }
      });
    });
  });
})(window, document);
